export default () => {

  // elements
  const els = {
    bar: document.querySelector('[data-announcement]'),
    close: document.querySelector('[data-announcement-close]'),
    body: document.body
  }

  const classes = {
    bodyAnnouncementShow: 'body--announcement-show'
  };

  if (els.bar) {
    //functions
    const showAnnouncement = () => {
      els.bar.style.maxHeight = `${els.bar.scrollHeight}px`;
    }

    const hideAnnouncement = () => {
      els.bar.style.maxHeight = 0;
			window.sessionStorage.setItem('hideAnnouncement', true);
    }
  
    // event listeners
    els.close.addEventListener('click', e => {
      e.preventDefault();
      hideAnnouncement();
    });

    // init
    if (!window.sessionStorage.getItem('hideAnnouncement')) {
      showAnnouncement();
    }
  }
};